module.exports = __webpack_public_path__ + "img/4.5f4a70e6.png";